import React, { useEffect, useState, lazy, Suspense } from "react";
import stores from "../../../stores";
import { Provider } from "mobx-react";
import AuthUserService from "../../../services/AuthUserService";
import ToastContainerWrapper from "../../ToastContainerWrapper";
import jwt_decode from "jwt-decode";
import { getCookie } from "../../../utils/helpers";

const SimpleConsent = lazy(() => import("../../CookieConsent/SimpleConsent"));

const RootLayout = props => {
  const { children, pageContext } = props;
  const { language } = pageContext;
  const [showConsent, setShowConsent] = useState(false);
  useEffect(() => {
    const user = AuthUserService.getCachedUser();

    if (user) {
      try {
        const { accessToken } = user;
        const decodedToken = jwt_decode(accessToken);
        const { roles, aud, exp, iat } = decodedToken || {};
        const additionalData = { roles, aud, exp, iat };
        stores.auth.setUser({ ...user, ...additionalData });
      } catch (e) {
        console.warn("Token decoding error:", e);
        stores.auth.setUser(user);
      }
    }

    const hasUserAcceptedConsent = getCookie("boattrip-google-consent");
    setShowConsent(!hasUserAcceptedConsent);
  }, []);

  return (
    <Provider {...stores}>
      {children}
      <ToastContainerWrapper />
      {showConsent && (
        <Suspense fallback={null}>
          <SimpleConsent isShowConsent={true} language={language} />
        </Suspense>
      )}
    </Provider>
  );
};

export default RootLayout;
